// BaseMapToggle.jsx – aligned with MapSection basemap keys
import React, { useState, useRef, useEffect } from "react";
import "./BaseMapToggle.css";

// Images – reused from your local assets
import MapFarsi from "../assets/images/Map-_Farsi.png";   // now used for satellite
import MapOSM from "../assets/images/Map_OSM.png";
import MapGIS from "../assets/images/Map_GIS.png";

// Keys must match the baseMaps object in MapSection: "osm", "satellite", "imagery"
const thumbnails = {
  satellite: MapFarsi,   // Google Satellite (default)
  osm: MapOSM,
  imagery: MapGIS,
};

const BaseMapToggle = ({ currentBaseMap, setBaseMap }) => {
  const [expanded, setExpanded] = useState(false);
  const containerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    if (!expanded) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [expanded]);

  const handleSelect = (key) => {
    setBaseMap(key);
    setExpanded(false);
  };

  return (
    <div className="basemap-toggle-wrapper" ref={containerRef}>
      {/* Collapsed state – single thumbnail */}
      {!expanded && (
        <div
          className="basemap-option active"
          onClick={() => setExpanded(true)}
          title="تغییر نقشه پایه"
        >
          <img src={thumbnails[currentBaseMap]} alt="نقشه فعال" />
        </div>
      )}

      {/* Expanded state – vertical upward list */}
      {expanded && (
        <div className="basemap-expanded-container">
          <div
            className={`basemap-option ${currentBaseMap === "satellite" ? "active" : ""}`}
            onClick={() => handleSelect("satellite")}
            title="ماهواره‌ای (Google)"
          >
            <img src={MapFarsi} alt="ماهواره‌ای" />
          </div>
          <div
            className={`basemap-option ${currentBaseMap === "osm" ? "active" : ""}`}
            onClick={() => handleSelect("osm")}
            title="نقشه خیابان (OSM)"
          >
            <img src={MapOSM} alt="نقشه خیابان" />
          </div>
          <div
            className={`basemap-option ${currentBaseMap === "imagery" ? "active" : ""}`}
            onClick={() => handleSelect("imagery")}
            title="ماهواره‌ای (ArcGIS)"
          >
            <img src={MapGIS} alt="ArcGIS" />
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseMapToggle;